// extracted by mini-css-extract-plugin
module.exports = {"lightMode":"styleConsts_lightMode__GwQQN","darkMode":"styleConsts_darkMode___bIkR","transitionThemeColors":"styleConsts_transitionThemeColors__w1rs1"};